import { render, staticRenderFns } from "./storesTable.vue?vue&type=template&id=1b534423"
import script from "./storesTable.vue?vue&type=script&lang=js"
export * from "./storesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports